'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectBoxLabelStyled = undefined;

var _templateObject = _taggedTemplateLiteral(['\n        width: ', ';\n      '], ['\n        width: ', ';\n      ']);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var propTypes = {
  labelPosition: _propTypes2.default.oneOf(['top', 'side']),

  /**
   * Define theme
   * See https://github.com/styled-components/styled-components/blob/master/docs/theming.md
   * for more information
   */
  theme: _propTypes2.default.object
};
var defaultProps = {
  labelPosition: 'top'
};
/** Prop Receivers */

var labelBase = function labelBase(_ref) {
  var labelPosition = _ref.labelPosition,
      themeFromProvider = _ref.theme;
  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var path = theme.reactackle.components.selectBox.label,
      source = labelPosition === 'top' ? path.positionTop : path.positionSide;
  var fontSize = source.fontSize,
      lineHeight = source.lineHeight,
      textTransform = source.textTransform,
      fontWeight = source.fontWeight;
  return (0, _styledComponents.css)(['font-size:', ';line-height:', ';text-transform:', ';font-weight:', ';', ''], (0, _reactackleCore.getValueString)(fontSize), lineHeight, textTransform, fontWeight, labelPosition === 'side' ? '\n        flex-direction: column;\n        justify-content: center;\n      ' : 'align-items: center;');
};

var labelSelectSpacing = function labelSelectSpacing(_ref2) {
  var labelPosition = _ref2.labelPosition,
      dense = _ref2.dense,
      fullWidth = _ref2.fullWidth,
      themeFromProvider = _ref2.theme,
      bordered = _ref2.bordered;
  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var key = labelPosition === 'top' ? 'positionTop' : 'positionSide',
      styleKey = bordered ? 'bordered' : 'underlined',
      path = theme.reactackle.components.selectBox.label[key].size[styleKey];
  var source = path;
  if (dense && !fullWidth) source = path.dense;else if (dense && fullWidth) source = path.denseFullWidth;else if (!dense && fullWidth) source = path.fullWidth;
  var labelSelectSpacing = (0, _reactackleCore.getValueString)(source.labelSelectSpacing);
  return labelPosition === 'top' ? 'margin-bottom: ' + labelSelectSpacing + ';' : 'margin-right: ' + labelSelectSpacing + ';';
};

var sizeProps = function sizeProps(_ref3) {
  var labelPosition = _ref3.labelPosition,
      dense = _ref3.dense,
      fullWidth = _ref3.fullWidth,
      themeFromProvider = _ref3.theme,
      bordered = _ref3.bordered;
  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var styleKey = bordered ? 'bordered' : 'underlined',
      path = theme.reactackle.components.selectBox.selectBox[styleKey].size;
  var source = path;
  if (dense && !fullWidth) source = path.dense;else if (dense && fullWidth) source = path.denseFullWidth;else if (!dense && fullWidth) source = path.fullWidth;
  var _source = source,
      paddingY = _source.paddingY;
  return labelPosition === 'side' && '\n    padding-bottom: ' + (0, _reactackleCore.getValueString)(paddingY) + ';\n  ';
};

var labelStyle = function labelStyle(_ref4) {
  var themeFromProvider = _ref4.theme,
      disabled = _ref4.disabled,
      colorScheme = _ref4.colorScheme,
      labelPosition = _ref4.labelPosition,
      focus = _ref4.focus;
  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var key = labelPosition === 'top' ? 'positionTop' : 'positionSide',
      path = theme.reactackle.components.selectBox.label[key].style;
  var source = null;

  if (!disabled) {
    if (colorScheme !== 'neutral') source = path[colorScheme];else if (focus) source = path.focus;else source = path;
  } else {
    source = path.disabled;
  }

  var _source2 = source,
      fontColor = _source2.fontColor;
  return 'color: ' + fontColor + ';';
};

var labelSideWidth = function labelSideWidth(_ref5) {
  var labelPosition = _ref5.labelPosition,
      themeFromProvider = _ref5.theme;
  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var source = theme.reactackle.components.selectBox.label.positionSide;
  var breakpoints = source.breakpoints.map(function (item) {
    return (0, _styledComponents.css)(['', ''], (0, _reactackleCore.media)(item.breakpoint)(_templateObject, (0, _reactackleCore.getValueString)(item.width)));
  });
  return labelPosition === 'side' && (0, _styledComponents.css)(['width:', ';', ';'], (0, _reactackleCore.getValueString)(source.width), breakpoints);
};
/** STYLES */


var SelectBoxLabelStyled = exports.SelectBoxLabelStyled = _styledComponents2.default.label.withConfig({
  displayName: 'SelectBoxLabelStyled'
})(['display:flex;user-select:none;', ';', ';', ';', ';', ';', ';'], labelBase, labelStyle, sizeProps, labelSelectSpacing, labelSideWidth, (0, _reactackleCore.transition)('color, font-size'));

SelectBoxLabelStyled.propTypes = propTypes;
SelectBoxLabelStyled.defaultProps = defaultProps;
SelectBoxLabelStyled.displayName = 'SelectBoxLabelStyled';